export const COLORS_LIGHT = {
	primary: "#316EE2",
	secondary: "#16D1D5",
	success: "#24BC6E",
	error: "#D44545",
	warning: "#E2BD07",
	disabled: "#C5C5C5",
	background: "#FFFFFF",
	backgroundBlue: "#D6E2F9",
	backgroundGray: "#EFEFEF",
	grayLight: "#DCDCDC",
	gray: "#454545",
	gray2: "#5D5D5D",
	gray3: "#6A6A6A",
	gray4: "#BBBBBB",
	divider: "#EFEFEF",
	black: "#000000",
	white: "#FFFFFF",
	input: "#FFFFFF",
	tableHeader: "#ECFAFF",
};

export const COLORS_DARK = {
	primary: "#316EE2",
	secondary: "#16D1D5",
	success: "#24BC6E",
	error: "#D44545",
	warning: "#E2BD07",
	disabled: "#6E6E6E",
	background: "#161616",
	backgroundBlue: "#0F1A2A",
	backgroundGray: "#111111",
	grayLight: "#4A4A4A",
	gray: "#E6E6E6",
	// gray2: "#B0B3B8",
	gray2: "#ffffff",
	gray3: "#9AA0A6",
	gray4: "#7C7F86",
	divider: "#111111",
	black: "#000000",
	white: "#FFFFFF",
	input: "#1E1E1E",
	tableHeader: "#161616",
};
